import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Register from "./Pages/register";
import Login from "./Pages/login";
import Forgot from "./Pages/forgot";
import Changepassowrd from "./Pages/changepassword";
import './App.css';
import Verification from "./Pages/kyc";
import KycVerification from "./Pages/kycverification";
import Profile from "./Pages/Profile";
import Support from "./Pages/Support";
import ChangeEmail_Password from "./Pages/ChangeEmail_Password";
import Faq from "./Pages/Faq";
import SupportTicket from "./Pages/SupportTicket";
import ReActivateAccount from "./Pages/ReactivateAccount";
import EditName from "./Pages/EditName";
import DepositSupport from "./Pages/DepositSupport";
import WithDrawSupport from "./Pages/WithDrawSupport";


import {socket} from './socket'
export default function App() {


  useEffect(()=>{
    socket.on("aw",()=>{
      
    })
  },[socket])


  useEffect(() => {
    if (process.env.NODE_ENV == "production") {
      console.log = () => {};
      console.warning = () => {};
      console.info = () => {};
      console.error = () => {};
    }
  }, []);

  return (
    <>

      <BrowserRouter>
        <Routes>
        <Route path="/" element={<Register />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot" element={<Forgot />} />
        <Route path="/resetpassword" element={<Changepassowrd />} />
        <Route path="/verification" element={<Verification/>} />
        <Route path="/kyc-verification" element={<KycVerification/>} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/support" element={<Support />} />
        <Route path="/edit-email" element={<ChangeEmail_Password />} />
        <Route path="/edit-password" element={<ChangeEmail_Password />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/support-ticket" element={<SupportTicket />} />
        <Route path="/reactivate" element={<ReActivateAccount />} />
        <Route path='/edit-name' element={<EditName/>} />
        <Route path='/deposit-support' element={<DepositSupport/>} />
        <Route path='/withdraw-support' element={<WithDrawSupport/>} />
        </Routes>
      </BrowserRouter>

    </>
  );
}

